<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="edit-outline"></nb-icon>
        <div class="ml-2" i18n>Manage Contributors</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>Contributors</strong>
    <p i18n>Enter the email of the people you want to allow editing of this DRB</p>
    <hr />
    <form #xliffForm="ngForm">
      <div *ngFor="let contributor of contributors; let i = index; trackBy: trackByIndex">
        <div class="row">
          <div class="col"><label i18n>Contributor:</label></div>
          <div class="col-9">
            <input
              id="{{ 'contributor' + i }}"
              name="{{ 'contributor' + i }}"
              nbInput
              fullWidth
              placeholder="Contributor {{ i + 1 }}"
              style="width: 100%"
              [(ngModel)]="contributors[i]"
            />
          </div>
        </div>
        <br />
      </div>
    </form>
    <p style="color: red; font-size: 12px">{{ errorMessage }}</p>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>Close</button>
      <button nbButton class="ml-3" status="success" (click)="save()" [disabled]="!xliffForm.form.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
